import i18next from 'i18next';
import trans from './assets/translations/index';
console.log(trans);

i18next
  .init({
    interpolation: {
      // React already does escaping
      escapeValue: false,
    },
    lng: 'sr',
    resources: 
    {
        en: {
            translation: trans.en,
        },
        sr: {
            translation: trans.sr,
        },
        fr: {
          translation: trans.fr,
      }
    },
  })

export default i18next;